import {NG_EVENT_PLUGINS} from "@taiga-ui/event-plugins";
import {BrowserAnimationsModule, provideAnimations} from "@angular/platform-browser/animations";
import {TuiAlert, TuiDialog} from "@taiga-ui/core";
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {apiJsonAcceptInterceptor} from "./@core/interceptors/api-json-accept.interceptor";
import {provideCharts, withDefaultRegisterables} from "ng2-charts";
import {Chart} from "chart.js";

import zoomPlugin from 'chartjs-plugin-zoom';
import DragData from "chartjs-plugin-dragdata";
import annotationPlugin from "chartjs-plugin-annotation";

Chart.register(zoomPlugin);
Chart.register(annotationPlugin);

export const appConfig: ApplicationConfig = {
  providers: [
    provideCharts(withDefaultRegisterables(), DragData, zoomPlugin, annotationPlugin),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiJsonAcceptInterceptor]), withInterceptorsFromDi()),
    importProvidersFrom(BrowserAnimationsModule, TuiAlert, TuiDialog),
    NG_EVENT_PLUGINS
  ]
};
